/* import __COLOCATED_TEMPLATE__ from './entries-table-edit-row.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export default class EntriesTableEditRowComponent extends Component
{
	@service store;

	@tracked bib;
	@tracked startTime;
	@tracked selectedClassId = null;

	originalClass = null;

	@action
	inserted()
	{
		if (!this.args.entry) {
			return;
		}
		this.bib = this.args.entry.bib;
		this.startTime = dayjs(this.args.entry.get('StartTimingRecordId.assignedStartTime')).format("HH:mm:ss");
		this.originalClass = this.args.entry.ClassId.content;
		this.selectedClassId = this.args.entry.ClassId?.id || null;
	}

	@action
	async save()
	{
		if (!this.args.entry) {
			return;
		}
		var startTimeEntered = this.startTime;
		var parsedStartTime = dayjs(startTimeEntered, "HH:mm:ss");

		var eventDate = dayjs(this.args.entry.get('EventId.date'));
		parsedStartTime = parsedStartTime
			.year(eventDate.year())
			.month(eventDate.month())
			.date(eventDate.date());

		var entry = this.args.entry;
		entry.bib = this.bib;

		// Apply class change
		if (this.selectedClassId === null) {
			entry.ClassId = null;
		} else if (this.selectedClassId !== this.originalClass?.id) {
			entry.ClassId = await this.store.findRecord('class', this.selectedClassId);
		}

		try
		{
			await entry.save()

			const sTR = await entry.get('StartTimingRecordId')
			sTR.assignedStartTime = new Date(parsedStartTime.toISOString());
			await sTR.save();
		}
		catch (error)
		{
			alert(error);
			this.cancel();
		}

		entry.set('showDetails',true);
		entry.set('isEditing',false);
	}
	
	@action
	cancel()
	{
		if (!this.args.entry) {
			return;
		}
		var entry = this.args.entry;
		entry.rollbackAttributes();
		entry.ClassId = this.originalClass;

		entry.set('showDetails',true);
		entry.set('isEditing',false);
	}
	
	@action
	statusSelectionChanged(browserEvent)
	{
		if (!this.args.entry) {
			return;
		}
		this.args.entry.status = browserEvent.target.value;
	}

	@action
	genderChanged(browserEvent)
	{
		if (!this.args.entry) {
			return;
		}
		var entry = this.args.entry;
		entry.gender = browserEvent.target.value;
		entry.ClassId = null;
	}

	@action
	classSelectionChanged(browserEvent)
	{
		if (!this.args.entry) {
			return;
		}
		let eventClass = browserEvent.target.value;
		this.selectedClassId = eventClass === '-' ? null : eventClass;
	}
}